module.exports = __webpack_public_path__ + "img/20.7b6b8566.png";